<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="aboutwidget__background module__background"
        >
        </app-modulebackground>
        <div
            class="aboutwidget__container module__container"
            v-bind:class="{ container__boxed: [1, 2].includes(module.layout.type) }"
        >
            <div class="aboutwidget__inner module__inner">
                <div class="aboutwidget__inner--main module__inner--main">
                    <div class="aboutwidget__inner-row module__inner-row">
                        <div class="aboutwidget__inner-col module__inner-col">
                            <div class="aboutwidget__content-block module__content-block">
                                <div
                                    class="aboutwidget__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1].includes(module.layout.type),
                                        'col__width--half': [2].includes(module.layout.type)
                                    }"
                                    v-if="module.data.title || module.data.subtitle"
                                >
                                    <div class="aboutwidget__inner-row module__inner-row">
                                        <div class="aboutwidget__inner-col module__inner-col">
                                            <div class="aboutwidget__header module__header">
                                                <h2
                                                    class="aboutwidget__title module__title font-h2 color-h2"
                                                    v-if="module.data.title"
                                                    v-html="module.data.title"
                                                ></h2>
                                                <h3
                                                    class="aboutwidget__subtitle module__subtitle font-h3 color-h3"
                                                    v-if="module.data.subtitle"
                                                    v-html="module.data.subtitle"
                                                ></h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="aboutwidget__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1].includes(module.layout.type),
                                        'col__width--half': [2].includes(module.layout.type)
                                    }"
                                    v-if="module.data.text || getPageUrlFromType('about')"
                                >
                                    <div
                                        class="aboutwidget__inner-row module__inner-row"
                                        v-if="module.data.text"
                                    >
                                        <div class="aboutwidget__inner-col module__inner-col">
                                            <div
                                                class="aboutwidget__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                    <div
                                        class="aboutwidget__inner-row module__inner-row"
                                        v-if="getPageUrlFromType('about')"
                                    >
                                        <div class="aboutwidget__inner-col module__inner-col">
                                            <div class="aboutwidget__cta module__cta">
                                                <app-modulebutton
                                                    :href="getPageUrlFromType('about')"
                                                    :custom-class="
                                                        'aboutwidget__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                    >Erfahren Sie mehr
                                                </app-modulebutton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleBackground from '@/components/assorted/ModuleBackground';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['getPageUrlFromType'])
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
